export default __webpack_public_path__ + "static/cortica-logo-2b482dd6c5738f51e2268de44019227f.svg";